import {Component, isDevMode, OnInit} from '@angular/core';
import {User} from '../../models/User';
import {Company} from '../../models/company';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ImageService} from '../services/ImageService';
import {AngularFireDatabase} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';
import {TimeTrackerService} from '../time-tracker-service.service';
import {Router} from "@angular/router";

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

    // Models
    user: User = new User();
    company: Company = new Company();
    termsAndConditions: Boolean = false;

    // FormGroups
    accountForm: FormGroup;
    companyForm: FormGroup;

    constructor(private _formBuilder: FormBuilder, public imageService: ImageService, public router: Router,
                public afAuth: AngularFireAuth, public af: AngularFireDatabase) {

    }

    ngOnInit() {

        this.accountForm = this._formBuilder.group({
            username: new FormControl('', Validators.compose([Validators.required])),
            ci: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required, Validators.min(4),
                () => {
                    if (this.accountForm && this.accountForm.controls.repeat_password) {
                        this.accountForm.controls.repeat_password.reset();
                    }
                    return null;
                }]),
            repeat_password: new FormControl('', [Validators.required, Validators.min(4),
                () => {
                    return (this.user.password !== this.user.repeat_password) ? {'distinct_password': true} : null;
                }])
        });

        this.companyForm = this._formBuilder.group({
            company_name: new FormControl('', [Validators.required, Validators.min(4)]),
            company_logo: new FormControl('', [])
        });

        if (isDevMode()) {
            this.user.username = 'Emilio';
            this.user.ci = '987654321';
            this.user.email = 'eyvind.coaquira@gmail.com';
            this.user.password = '987654321';
            this.user.repeat_password = '987654321';
            this.company.name = 'New Vision Data';
        }
    }

    public validateForms(accountForm, companyForm): boolean {
        return !(accountForm.valid && companyForm.valid && this.termsAndConditions);
    }

    public registerAccount() {
        const user = Object.assign({}, this.user);
        const company = Object.assign({}, this.company);
        const companyId = TimeTrackerService.guid();

        delete user.password;
        delete user.repeat_password;

        user.active = true;
        user.isAdmin = true;
        user.companyId = companyId;
        user.userType = 'PLANT_WORKER';
        company.id = companyId;
        company.active = true;

        this.afAuth.auth.createUserWithEmailAndPassword(this.user.email, this.user.password)
            .then(firebaseUser => {
                user.id = firebaseUser.uid;
                this.af.object(TimeTrackerService.COMPANIES + '/' + companyId)
                    .set(company)
                    .then(() => {
                        this.af.object(TimeTrackerService.USERS + '/' + firebaseUser.uid)
                            .set(user)
                            .then(() => {
                                this.router.navigate(['/']);
                            }, () => {
                                this.af.object(TimeTrackerService.COMPANIES + '/' + companyId).remove();
                            });
                    });
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts